;(function($) {
    var subMenu = new Object();
    subMenu.hoverMe = function() {
        var navigation = $('.main-navigation'),
            hasChildren = $('.menu-item-has-children'),
            subMenu = $('.sub-menu');

        $.each( hasChildren, function( i ) {
            $(this).on('click', function(e) {
                e.preventDefault();
                $(this).children('.sub-menu').toggleClass('showme');
                $(this).toggleClass('showmyborder');
            });
            $(this).children('.sub-menu').click(function (e) {
                e.stopPropagation();
            });
        });

    }

    window.subMenu = subMenu;
    var menuMobile = new Object();
    menuMobile.showAndClose = function() {
        var nav = $('.main-navigation'),
            button = $('.menu-toggle');

        button.on('click', function() {
            nav.toggle();
            nav.toggleClass('smallIn');
            button.toggleClass('open');
        });

        //register the resize function
        $(window).resize(checkWindowWidth);

        function checkWindowWidth() {

            var width = $(window).width();

            if (width < 901) {
                button.removeClass('open');
                nav.removeClass('smallIn');
                nav.hide();
            } else {
                nav.show();
            }
        }
    };
    window.menuMobile = menuMobile;
})(jQuery);